const vuexModules = {
    namespaced: true,
    state: {
        isLoading: true,
        isOpacityLoading: false
    },
    mutations: {
        // 不透明
        setIsLoading (state, isLoading) {
            state.isLoading = isLoading;
        },
        // 半透明
        setIsOpacityLoading (state, isOpacityLoading) {
            state.isOpacityLoading = isOpacityLoading;
        }
    }
};

export default vuexModules;
